import { IntlShape } from 'react-intl';
import { SongUploadError } from '../songUpload';
import { soundCloudUploadMessages as m } from '../soundCloudMessages';

/** The line under the Upload button (design c3 note, c5). */
export function songUploadErrorText(intl: IntlShape, error: SongUploadError): string {
  switch (error) {
    case 'tooSoon':
      return intl.formatMessage(m.errorTooSoon);
    case 'notConnected':
      return intl.formatMessage(m.errorNotConnected);
    case 'notEnabled':
      return intl.formatMessage(m.errorNotEnabled);
    case 'alreadyLive':
      return intl.formatMessage(m.errorAlreadyLive);
    case 'masterMissing':
      return intl.formatMessage(m.masterMissing);
    case 'masterProcessing':
      return intl.formatMessage(m.masterProcessing);
    case 'masterFailed':
      return intl.formatMessage(m.masterFailed);
    case 'generic':
      return intl.formatMessage(m.errorGeneric);
  }
}
